"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimension = void 0;
/**
 * Функция для определения номера dimension, а также типа передаваемых данных
 * В качестве generic указывается тип данных в dimension
 * @param dimensionNumber номер dimension
 */
function dimension(dimensionNumber) {
    return dimensionNumber;
}
exports.dimension = dimension;

//# sourceMappingURL=dimension.js.map
